/* ════════════════════════════════════════════════════════════════════════
   Alphanna — carrinho lateral: subscrição e código de desconto
   ────────────────────────────────────────────────────────────────────────
   03/10/2026.

   Subscrição: troca cada linha avulsa pelo plano do produto com
   /cart/change.js (line + quantity + selling_plan). A última chamada pede
   também o HTML da secção do carrinho e entrega-o ao carrinho do tema, que
   é quem sabe redesenhar-se — o mesmo caminho já usado nos botões de
   adicionar das outras secções.

   Código de desconto: a Shopify não aplica códigos no carrinho. O código
   entra pela rota /discount/<código>?redirect=/checkout, que o aplica e
   leva a pessoa para a finalização.
   ════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  function drawerEl() {
    return document.querySelector('cart-drawer');
  }

  function handOverToTheme(state, sectionId) {
    var drawer = drawerEl();
    var html = state && state.sections && sectionId ? state.sections[sectionId] : null;
    if (!drawer || !html || typeof drawer.purchaseHandler !== 'function') {
      window.location.reload();
      return;
    }
    try {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      if (typeof drawer.updateAsideProductsByParsedState === 'function') drawer.updateAsideProductsByParsedState(state);
      if (typeof drawer.updateEmptyStatus === 'function') drawer.updateEmptyStatus();
      drawer.purchaseHandler(doc, state);
    } catch (err) {
      window.location.reload();
    }
  }

  function subscrever(btn) {
    var linhas = (btn.getAttribute('data-lines') || '').split(',').filter(Boolean);
    var planos = (btn.getAttribute('data-plans') || '').split(',').filter(Boolean);
    var quantidades = (btn.getAttribute('data-qty') || '').split(',').filter(Boolean);
    if (!linhas.length) return;

    var drawer = drawerEl();
    var sectionId = drawer && drawer.getAttribute('data-section-id');
    btn.disabled = true;
    btn.classList.add('is-loading');

    /* De trás para a frente: trocar o plano não muda a ordem das linhas,
       mas se alguma linha se fundir com outra os índices seguintes descem. */
    var i = linhas.length - 1;

    function passo() {
      if (i < 0) return;
      var ultima = i === 0;
      /* A quantidade tem de ir explícita: sem ela a Shopify repõe 1. */
      var corpo = {
        line: parseInt(linhas[i], 10),
        quantity: parseInt(quantidades[i], 10) || 1,
        selling_plan: parseInt(planos[i], 10)
      };
      if (ultima && sectionId) {
        corpo.sections = sectionId;
        corpo.sections_url = window.location.pathname;
      }
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(corpo)
      })
        .then(function (r) {
          if (!r.ok) throw new Error('change_' + r.status);
          return r.json();
        })
        .then(function (state) {
          i -= 1;
          if (i >= 0) {
            passo();
          } else {
            handOverToTheme(state, sectionId);
          }
        })
        .catch(function () {
          btn.classList.remove('is-loading');
          btn.disabled = false;
          var txt = btn.querySelector('.alph-cart-sub__btn-text');
          if (txt) {
            var orig = txt.textContent;
            txt.textContent = 'Tente novamente';
            setTimeout(function () { txt.textContent = orig; }, 2000);
          }
        });
    }
    passo();
  }

  function aplicarCodigo(btn) {
    var caixa = btn.closest('.alph-cart-code');
    var input = caixa && caixa.querySelector('[data-alph-code-input]');
    var codigo = input && input.value.trim();
    if (!codigo) {
      if (input) input.focus();
      return;
    }
    btn.disabled = true;
    window.location.href = '/discount/' + encodeURIComponent(codigo) + '?redirect=/checkout';
  }

  document.addEventListener('click', function (e) {
    var sub = e.target.closest('[data-alph-sub-btn]');
    if (sub) {
      e.preventDefault();
      subscrever(sub);
      return;
    }
    var cod = e.target.closest('[data-alph-code-btn]');
    if (cod) {
      e.preventDefault();
      aplicarCodigo(cod);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var input = e.target.closest('[data-alph-code-input]');
    if (!input) return;
    e.preventDefault();
    var btn = input.closest('.alph-cart-code').querySelector('[data-alph-code-btn]');
    if (btn) aplicarCodigo(btn);
  });
})();
